import React from 'react';

export const Poemist = require('../modules/poemist/Poemist').default;
export const PositiveQuotes = require('../modules/positiveQuotes/PositiveQuotes')
  .default;
export const MoviesQuotes = require('../modules/moviesQuotes/MoviesQuotes')
  .default;
export const Home = require('../modules/home/Home').default;

export const routes = [
  // render public pages first
  {
    path: '/positive_quotes',
    component: PositiveQuotes,
    privateRoute: false,
  },
  {
    path: '/movies_quotes',
    component: MoviesQuotes,
    privateRoute: false,
  },
  {
    path: '*/poems',
    component: Poemist,
    privateRoute: false,
  },
  {
    path: '/poems',
    component: Poemist,
    privateRoute: false,
  },
  {
    path: '/',
    component: Home,
    privateRoute: false,
  },
];
